{
  "phenotypic_data": {
    "regexp": "^[\\/\\\\](?:phenotype)[\\/\\\\](?:.*\\.tsv|.*\\.json)$"
  }
}
